<template lang="pug">

    form.ui.form(v-on:submit.prevent='submit()')

        //- Zusätzliche Angaben
        step-indicator(v-bind:activeStep='3')


        .ui.top.attached.header Allgemeine Angaben:
        .ui.bottom.attached.segment
            general-information-form(
                ref="generalInformation"
                v-bind:company='purchaserModel'
                v-model='model'
            )

        .ui.top.attached.header Zusätzliche Angaben:
        .ui.bottom.attached.segment
            additional-information-form(
                ref="additionalInformation"
                v-bind:country-models='countries'
                v-bind:internal-shipping-address-models='internalShippingAddresses'
                v-bind:media-production-person-models='mediaProductionPersons'
                v-bind:media-production-user-models='mediaProductionUsers'
                v-bind:purchaser-models='purchaserModels'
                v-model='model'
            )

        .ui.top.attached.header Proof: (nur hausintern)
        .ui.bottom.attached.segment
            proof-form(
                v-bind:shipping-address-models="shippingAddressModels"
                v-model="proof"
            )

        wizard-navigation(v-on:back="back()")

</template>

<script>
    import * as R from 'ramda'
    import store from '@/store'
    import Modal from '@/components/app/Modal.vue'
    import AdditionalInformationForm from '@/components/products/forms/AdditionalInformationForm.vue'
    import GeneralInformationForm from '@/components/products/forms/GeneralInformationForm.vue'
    import ProofForm from '@/components/products/forms/ProofForm.vue'
    import StepIndicator from '@/components/products/StepIndicator.vue'
    import WizardNavigation from '@/components/products/WizardNavigation.vue'

    //noinspection JSUnusedLocalSymbols,JSUnusedGlobalSymbols
    export default {
        name: 'products-create-step3-view',

        beforeRouteEnter(to, from, next) {
            if (store.getters['products/draft'].type === undefined) {
                next({ name: 'products/create' })
            }

            return Promise.all([

                // Laender laden
                store.dispatch('countries/loadAll'),

                // Interne Lieferadressen laden
                store.dispatch('addresses/loadAllByCompanyIdAndIsShippingAddress', { companyId: 2 }),

                // Alle Medienproduktioner laden
                store.dispatch('users/loadAllByHasMediaProductionRole').then(() => {
                    const users = store.getters['users/allByHasMediaProductionRole']

                    return Promise.all(
                        users.map(user => store.dispatch('persons/loadOne', { id: user.person }))
                    )
                }),

                // Alle Unternehmen laden
                store.dispatch('companies/loadAllByIsPurchaser'),

            ]).then(next)
        },

        created() {
            this.$scrollTo('body')
        },

        components: {
            AdditionalInformationForm, GeneralInformationForm, Modal, ProofForm, StepIndicator, WizardNavigation
        },

        computed: {

            countries() {
                return store.getters['countries/all']
            },

            internalShippingAddresses() {
                return store.getters['addresses/allByCompanyIdAndIsShippingAddress'](2)
            },

            isInvalid() {
                return this.$refs.generalInformation.$v.$invalid ||
                    this.$refs.additionalInformation.$v.$invalid
            },

            mediaProductionUsers() {
                return store.getters['users/allByHasMediaProductionRole']
            },

            mediaProductionPersons() {
                return this.mediaProductionUsers
                    .map(user => store.getters['persons/byId'](user.person))
            },

            model: {
                get() { return this.$store.getters['products/draft'] || {} },
                set(model) { this.$store.commit('products/REPLACE_DRAFT', { draft: model }) }
            },

            proof: {
                get() { return this.model.proof || {} },
                set(value) { this.model = { ...this.model, proof: value }}
            },

            purchaserModel() {
                return R.ifElse(
                    // Pruefen ob Unternehmens-ID gueltig ist
                    R.is(Number),

                    // Dann Unternehmen holen
                    store.getters['companies/byId'],

                    // Ansonsten leeren Objekt zurueckgeben
                    R.always({})

                )(this.model.company)
            },

            purchaserModels() {
                return store.getters['companies/allByIsPurchaser']
            },

            shippingAddressModels() {
                return store.getters['addresses/allByCompanyIdAndIsShippingAddress'](this.model.company)
            },

        },

        methods: {

            back() {
                this.$router.push({
                    name: 'products/create/step2',
                    params: this.$route.params
                })
            },

            async submit() {
                // Embedded-Forms als "submitted" markieren
                this.$refs.generalInformation.$v.$touch()
                this.$refs.additionalInformation.$v.$touch()

                // Pruefen ob alle Formular valide sind
                if (this.isInvalid) {
                    this.$scrollToAndFocus('.field.error')
                    return
                }

                // Belegexemplare (inkl. Empfänger) validieren
                if (!await this.$refs.additionalInformation.validate()) {
                    this.$scrollToAndFocus('.field.error')
                    return
                }

                // Auf zu Step 4!
                this.$router.push({
                    name: 'products/create/step4',
                    params: this.$route.params
                })
                
            }

        },


        watch: {

            'model.company'(companyId) {
                // Lieferadressen des Unternehmens laden
                store.dispatch('addresses/loadAllByCompanyIdAndIsShippingAddress', { companyId })
            }

        }

    }

</script>

<!--suppress CssUnusedSymbol -->
<style>

    .v--modal-overlay {
        background: rgba(0, 0, 0, 0.85);
    }

</style>
